/*eslint-disable no-undef */
import Vue from "vue";
import moment from "vue-moment";
import _ from "lodash";
import { AsYouType } from "libphonenumber-js";
import SessionUser from "./session-user";
import Validator from "./validator";
import Formatter from "./formatter";
import DateTime from "./date-time";
import Converter from "./converter";

Object.defineProperty(Vue.prototype, "$_", { value: _ });
Object.defineProperty(Vue.prototype, "$parsePhone", { value: new AsYouType("CA") });
Object.defineProperty(Vue.prototype, "$sessionUser", { value: SessionUser });
Object.defineProperty(Vue.prototype, "$validator", { value: Validator });
Object.defineProperty(Vue.prototype, "$formatter", { value: Formatter });
Object.defineProperty(Vue.prototype, "$datetime", { value: DateTime });
Object.defineProperty(Vue.prototype, "$converter", { value: Converter });
Object.defineProperty(Vue.prototype, "$stripe", { value: Stripe(process.env.STRIPE_PUBLISHABLE_API_KEY) });

export default Vue.use(moment);



// WEBPACK FOOTER //
// ./src/helpers/index.js